export const BOX_COLORS = {
  default: "default",
  shade: "shade",
  light: "light",
  accent: "accent",
};
